import { IAppState } from '../../app.types';
import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './settings.types';

const resourceSelectors = generateResourceSelectors<types.ISettings>((state) => state.resource.settings);

export const settingsSelectors = {
  ...resourceSelectors,
  selectCurrentSettings: (state: IAppState): types.ISettings | null => {
    return resourceSelectors.selectResourceList(state)[0] ?? null;
  },
};
